//開發元件使用
import Vue from "vue";
import "@/adsmart-ui/index.js";

import allBoardDataLab from "@/data/allBoardData.lab.json";
import allBoardDataStaging from "@/data/allBoardData.staging.json";
import allBoardDataProd from "@/data/allBoardData.prod.json";

const dataMaps = {
  dMap: new Map(),
  sMap: new Map(),
  cMap: new Map()
};

const setMaps = (data, envName, dataMaps) => {
  const { dMap, sMap, cMap } = dataMaps;
  data.forEach(board => {
    const {
      device: dName,
      siteIdentify: sHash,
      siteId: sId,
      siteName: sName,
      channelIdentify: cHash,
      channelId: cId,
      channelName: cName,
      identify: bHash,
      // id: bId,
      name: bName
    } = board;
    // const isOnline = !board.status;
    // const isSiteHasAllEnv =
    //   envName !== "prod" && !dMap?.get(dName)?.get(sHash)?.env?.has("prod");
    // const isChannelHasAllEnv =
    //   envName !== "prod" && !sMap?.get(sHash)?.get(cHash)?.env?.has("prod");
    // if (isOnline || isSiteHasAllEnv || isChannelHasAllEnv) return;
    const getInfoMap = (map, key) => {
      if (map.has(key)) {
        return map.get(key);
      } else {
        const infoMap = new Map();
        map.set(key, infoMap);
        return infoMap;
      }
    };
    const getInfoData = (map, key, name) => {
      const infoData = map.get(key);
      if (infoData) {
        return infoData;
      } else {
        const newInfoData = { name: name, env: new Map() };
        map.set(key, newInfoData);
        return newInfoData;
      }
    };
    const setEnvData = (map, envName, data) => {
      const envMap = map;
      if (!envMap.has(envName)) {
        envMap.set(envName, data);
      }
    };
    const sInfoMap = getInfoMap(dMap, dName);
    const sInfoData = getInfoData(sInfoMap, sHash, sName);
    setEnvData(sInfoData.env, envName, { id: sId });
    const cInfoMap = getInfoMap(sMap, sHash);
    const cInfoData = getInfoData(cInfoMap, cHash, cName);
    setEnvData(cInfoData.env, envName, { id: cId });
    const bInfoMap = getInfoMap(cMap, cHash);
    const bInfoData = getInfoData(bInfoMap, bHash, bName);
    setEnvData(bInfoData.env, envName, board);
  });
};

setMaps(allBoardDataProd.response, "prod", dataMaps);
setMaps(allBoardDataStaging.response, "staging", dataMaps);
setMaps(allBoardDataLab.response, "lab", dataMaps);

window.dataMaps = dataMaps;

import App from "./App.vue";
import router from "./router/index";

Vue.config.productionTip = false;

const app = new Vue({
  router,
  render: h => h(App)
});
app.$mount("#app");
